import React from 'react'
import createSvgIcon from 'client/icons/createSvgIcon'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M19 3.5C19 3.8 19.2 4 19.5 4C20.9 4 22 5.1 22 6.5V7.5C22 8.9 20.9 10 19.5 10H19C18.4 10 18 9.6 18 9C18 8.4 18.4 8 19 8H19.5C19.8 8 20 7.8 20 7.5V6.5C20 6.2 19.8 6 19.5 6C18.1 6 17 4.9 17 3.5V3C17 2.4 17.4 2 18 2C18.6 2 19 2.4 19 3V3.5ZM14.7 9.4C18.2 10.5 20.8 13.7 21 17.5C21.6 17.9 22 18.7 22 19.5C22 20.9 20.9 22 19.5 22H4.5C3.1 22 2 20.9 2 19.5C2 18.7 2.4 18 3 17.5C3.2 13.7 5.8 10.5 9.4 9.4C9.1 9 9 8.5 9 8C9 6.3 10.3 5 12 5C13.7 5 15 6.3 15 8C15 8.5 14.9 9 14.7 9.4ZM12 7C11.4 7 11 7.4 11 8C11 8.6 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7ZM18.9 17C18.4 13.6 15.5 11 12 11C8.5 11 5.6 13.6 5.1 17H18.9ZM4 19.5C4 19.8 4.2 20 4.5 20H19.5C19.8 20 20 19.8 20 19.5C20 19.2 19.8 19 19.5 19H4.5C4.2 19 4 19.2 4 19.5Z"
  />,
  'Dining'
)
